<template>
  <main class="legal-page">
    <article class="legal-content">
      <router-link class="back-link" to="/">← Retour à l'accueil</router-link>

      <h1>Politique de confidentialité</h1>
      <p class="update-date">Dernière mise à jour : 15 juin 2026</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          La présente politique de confidentialité explique comment Fidmarket
          collecte, utilise et protège les données personnelles dans le cadre de
          son service.
        </p>
        <p>
          Fidmarket est une solution numérique destinée aux commerçants,
          notamment aux commerçants de marché, permettant de gérer des cartes de
          fidélité, des clients, des ventes, des journées de marché, des
          statistiques, des prévisions indicatives et des annonces.
        </p>
        <p>
          Pour toute question relative aux données personnelles, vous pouvez
          nous contacter à l'adresse suivante :
          <a href="mailto:contact@fidmarket.fr">contact@fidmarket.fr</a>.
        </p>
      </section>

      <section>
        <h2>2. Responsable du traitement</h2>
        <p>
          Le responsable du traitement est l'éditeur du service Fidmarket, tel
          qu'indiqué dans les mentions légales du site.
        </p>
        <p>
          Contact :
          <a href="mailto:contact@fidmarket.fr">contact@fidmarket.fr</a>
        </p>
      </section>

      <section>
        <h2>3. Données collectées</h2>
        <p>
          Dans le cadre de l'utilisation de Fidmarket, les données suivantes
          peuvent être collectées :
        </p>
        <h3>Données relatives aux commerçants :</h3>
        <ul>
          <li>nom, prénom ou raison sociale ;</li>
          <li>coordonnées de contact ;</li>
          <li>informations de connexion ;</li>
          <li>informations liées à l'activité commerciale ;</li>
          <li>données de facturation ;</li>
          <li>préférences et paramètres du compte.</li>
        </ul>
        <h3>Données relatives aux clients fidélité :</h3>
        <ul>
          <li>prénom et nom si renseignés ;</li>
          <li>numéro de téléphone si renseigné ;</li>
          <li>numéro de carte fidélité ;</li>
          <li>identifiant ou token public de carte digitale ;</li>
          <li>points fidélité ;</li>
          <li>historique de passages ou achats fidélisés ;</li>
          <li>récompenses ou bons d'achat associés.</li>
        </ul>
        <h3>Données d'utilisation :</h3>
        <ul>
          <li>actions réalisées dans l'application ;</li>
          <li>dates de connexion ;</li>
          <li>données techniques nécessaires au fonctionnement du service ;</li>
          <li>
            informations liées aux journées de marché, ventes, statistiques et
            prévisions.
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Finalités du traitement</h2>
        <p>Les données sont utilisées pour :</p>
        <ul>
          <li>créer et gérer les comptes commerçants ;</li>
          <li>permettre l'utilisation du service Fidmarket ;</li>
          <li>gérer les clients fidélité ;</li>
          <li>attribuer et suivre les points fidélité ;</li>
          <li>générer des cartes physiques ou digitales ;</li>
          <li>enregistrer les ventes et journées de marché ;</li>
          <li>afficher les cartes digitales publiques ;</li>
          <li>produire des statistiques et prévisions indicatives ;</li>
          <li>gérer les annonces commerçants ;</li>
          <li>assurer la facturation ;</li>
          <li>améliorer le service ;</li>
          <li>assurer la sécurité et le bon fonctionnement de l'application ;</li>
          <li>répondre aux demandes de contact ou de support.</li>
        </ul>
      </section>

      <section>
        <h2>5. Base légale du traitement</h2>
        <p>Selon les cas, les traitements peuvent reposer sur :</p>
        <ul>
          <li>l'exécution d'un contrat ou de mesures précontractuelles ;</li>
          <li>
            l'intérêt légitime de Fidmarket à fournir, sécuriser et améliorer
            son service ;
          </li>
          <li>
            le respect d'obligations légales, notamment comptables et fiscales ;
          </li>
          <li>le consentement lorsque celui-ci est requis.</li>
        </ul>
      </section>

      <section>
        <h2>6. Données des clients des commerçants</h2>
        <p>
          Les commerçants utilisant Fidmarket restent responsables des données
          qu'ils collectent auprès de leurs propres clients dans le cadre de
          leur programme de fidélité.
        </p>
        <p>
          Le commerçant doit informer ses clients de l'utilisation de leurs
          données et respecter la réglementation applicable en matière de
          protection des données personnelles.
        </p>
        <p>
          Fidmarket fournit un outil technique permettant la gestion du
          programme de fidélité, mais ne se substitue pas au commerçant dans ses
          obligations légales vis-à-vis de ses clients.
        </p>
      </section>

      <section>
        <h2>7. Destinataires des données</h2>
        <p>Les données peuvent être accessibles :</p>
        <ul>
          <li>au commerçant concerné ;</li>
          <li>
            à Fidmarket pour les besoins de gestion, maintenance, support et
            sécurité ;
          </li>
          <li>
            aux prestataires techniques nécessaires au fonctionnement du
            service ;
          </li>
          <li>aux autorités compétentes si la loi l'exige.</li>
        </ul>
        <p>Fidmarket ne vend pas les données personnelles à des tiers.</p>
      </section>

      <section>
        <h2>8. Durée de conservation</h2>
        <p>
          Les données sont conservées pendant la durée nécessaire aux finalités
          pour lesquelles elles sont traitées.
        </p>
        <p>
          Les données liées au compte commerçant sont conservées pendant la
          durée d'utilisation du service, puis archivées ou supprimées
          conformément aux obligations légales applicables.
        </p>
        <p>
          Les données de facturation peuvent être conservées pendant les durées
          légales comptables et fiscales.
        </p>
        <p>
          Les données clients fidélité peuvent être supprimées ou anonymisées
          sur demande, sous réserve des obligations légales ou contractuelles
          applicables.
        </p>
      </section>

      <section>
        <h2>9. Sécurité</h2>
        <p>
          Fidmarket met en œuvre des mesures raisonnables pour protéger les
          données contre la perte, l'accès non autorisé, la modification ou la
          divulgation.
        </p>
        <p>Ces mesures peuvent inclure notamment :</p>
        <ul>
          <li>authentification des utilisateurs ;</li>
          <li>contrôle des accès ;</li>
          <li>filtrage des données par commerçant ;</li>
          <li>sécurisation des échanges ;</li>
          <li>sauvegardes et maintenance technique.</li>
        </ul>
        <p>
          Aucun système ne pouvant garantir une sécurité absolue, l'utilisateur
          doit également veiller à protéger ses identifiants et accès.
        </p>
      </section>

      <section>
        <h2>10. Cartes digitales et QR codes</h2>
        <p>
          Les cartes digitales Fidmarket peuvent être accessibles via un lien
          ou un QR code contenant un identifiant public.
        </p>
        <p>
          Ces pages affichent uniquement les informations nécessaires au suivi
          de fidélité du client.
        </p>
        <p>
          Le commerçant doit veiller à distribuer et utiliser les cartes de
          manière adaptée et conforme à son activité.
        </p>
      </section>

      <section>
        <h2>11. Cookies et données techniques</h2>
        <p>
          Fidmarket peut utiliser des cookies ou technologies similaires
          nécessaires au fonctionnement du service, notamment pour :
        </p>
        <ul>
          <li>maintenir la session utilisateur ;</li>
          <li>sécuriser l'accès ;</li>
          <li>mémoriser certains paramètres ;</li>
          <li>améliorer l'expérience utilisateur.</li>
        </ul>
        <p>
          Si des cookies non strictement nécessaires sont ajoutés
          ultérieurement, une information ou un consentement spécifique pourra
          être mis en place.
        </p>
      </section>

      <section>
        <h2>12. Droits des personnes concernées</h2>
        <p>
          Conformément à la réglementation applicable, les personnes concernées
          peuvent disposer des droits suivants :
        </p>
        <ul>
          <li>droit d'accès ;</li>
          <li>droit de rectification ;</li>
          <li>droit d'effacement ;</li>
          <li>droit d'opposition ;</li>
          <li>droit à la limitation du traitement ;</li>
          <li>droit à la portabilité lorsque applicable.</li>
        </ul>
        <p>
          Pour exercer ces droits, une demande peut être envoyée à :
          <a href="mailto:contact@fidmarket.fr">contact@fidmarket.fr</a>
        </p>
        <p>Une vérification d'identité pourra être demandée si nécessaire.</p>
      </section>

      <section>
        <h2>13. Réclamation</h2>
        <p>
          En cas de difficulté concernant le traitement de vos données
          personnelles, vous pouvez contacter Fidmarket à l'adresse :
          <a href="mailto:contact@fidmarket.fr">contact@fidmarket.fr</a>
        </p>
        <p>
          Vous pouvez également introduire une réclamation auprès de la CNIL si
          vous estimez que vos droits ne sont pas respectés.
        </p>
      </section>

      <section>
        <h2>14. Modification de la politique</h2>
        <p>
          Fidmarket peut modifier la présente politique de confidentialité afin
          de l'adapter à l'évolution du service, de son activité ou de la
          réglementation.
        </p>
        <p>
          La version applicable est celle publiée en ligne au moment de la
          consultation.
        </p>
      </section>

      <section>
        <h2>15. Contact</h2>
        <p>
          Pour toute question relative à cette politique de confidentialité ou
          à vos données personnelles :
        </p>
        <p><a href="mailto:contact@fidmarket.fr">contact@fidmarket.fr</a></p>
      </section>
    </article>
  </main>
</template>

<script>
export default {
  name: 'ConfidentialiteView'
}
</script>

<style scoped>
.legal-page {
  --cream: #F5EDD6;
  --forest: #1A3A2A;
  min-height: 100vh;
  background: var(--cream);
  padding: clamp(28px, 6vw, 72px) clamp(18px, 5vw, 40px);
}

.legal-content {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
}

.back-link {
  display: inline-block;
  margin-bottom: clamp(36px, 7vw, 64px);
  color: var(--forest);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}

.back-link:hover {
  text-decoration: underline;
}

h1,
h2,
h3,
a {
  color: var(--forest);
}

h1 {
  margin: 0 0 12px;
  font-size: clamp(30px, 6vw, 48px);
  letter-spacing: 0.04em;
}

.update-date {
  margin-bottom: clamp(36px, 7vw, 56px);
  font-weight: 600;
}

section {
  margin-bottom: 34px;
}

h2 {
  margin: 0 0 12px;
  font-size: clamp(20px, 4vw, 25px);
}

h3 {
  margin: 20px 0 8px;
  font-size: clamp(16px, 3vw, 19px);
}

p,
li {
  color: #33483c;
  font-size: clamp(15px, 2.5vw, 17px);
  line-height: 1.75;
}

p {
  margin: 0 0 12px;
}

ul {
  margin: 0 0 12px;
  padding-left: 24px;
}

li {
  margin-bottom: 5px;
}

@media (max-width: 480px) {
  .legal-page {
    padding-top: 24px;
  }

  section {
    margin-bottom: 28px;
  }
}
</style>
